import UserProfilePanel from '../components/auth/user-profile/UserProfilePanel';

function UserProfile() {
  return <UserProfilePanel />;
}

export default UserProfile;
